export const UPDATE_FOUND = (state) => {
  state.updateInProgress = true;
};

export const UPDATED_PWA = (state) => {
  state.updateInProgress = false;
};

export const updateClientWindowSize = (state, payload) => {
  state.size = payload;
};

export const updateDark = (state, payload) => {
  localStorage.setItem("dark", payload);

  state.dark = payload;
};

export const updateMini = (state, payload) => {
  localStorage.setItem("mini", payload);

  state.mini = payload;
};

export const updateDeclinedPWA = (state, payload) => {
  localStorage.setItem("declined-pwa", payload);

  state.declinedPWA = payload;
};

export const updateInstalledPWA = (state, payload) => {
  localStorage.setItem("installed-pwa", payload);

  state.installedPWA = payload;
};

export const updateNetworkStatus = (state, payload) => {
  state.connected = payload;
};

export const updateActiveRequests = (state, payload) => {
  state.activeRequests = payload;
};


export const addNotification = (state, payload) => {
  state.sysNotifications.push({
    id: new Date().toISOString(),
    show: true,
    auto_dismiss: true,
    ...payload
  });
};

export const removeNotification = (state, id) => {
  state.sysNotifications = state.sysNotifications.filter(i => i.id != id);
};


export const clearNotifications = (state) => {
  state.sysNotifications = [];
};